import { TenantApp } from "../../types";
import { MOCK_POIS } from "./pois";

export const MOCK_TENANT: TenantApp = {
    tenantId: 'tenant-01',
    segmentId: 'localhost',
    saltKey: 's3cr3tK3y',
    name: 'Demo park 01',
    description: 'Demo park 01 è una demo',
    branding: {
        //logo: 'https://example.com/logo.png',
        theming: {
            lightMode: 'emerald',
            darkMode: 'coffee'
        },
        showNameInHeader: true,
        showDescriptionInHeader: true,
        logoSize: 11,
        logoDark: false
    },
    subscription: {
        plan: 'premium',
        status: 'active',
        updateFrequency: 'realtime',
        features: ['custom-map', 'analytics', 'multi-language'],
    },
    languages: [
        { code: 'en', label: 'English' },
        { code: 'it', label: 'Italiano' },
        { code: 'de', label: 'Deutsch' },
        { code: 'fr', label: 'Français' }
    ],
    pois: MOCK_POIS,
    hubs: [{ id: 1, lastUpdate: 1704067200000 }],
    ble: [
        { identifier: 1, busy: false },
        { identifier: 2, busy: false },
        { identifier: 3, busy: false }
    ],
    mapConfig: {
        tileUrl: 'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png',
        //imageUrl: '/maps/california/camping_california_map_overlay_1768600036878.png',
        zoom: 18,
        center: {
            lt: 45.45668913567405,
            lg: 10.712732468903363
        },
        bounds: {
            sw: {
                lt: 45.453836814572746,
                lg: 10.709470902764746
            },
            ne: {
                lt: 45.45802869842727,
                lg: 10.71613350987907
            }
        },
        minZoom: 16,
        maxZoom: 30
    },
    contactInfo: {
        email: 'info@parco-indiana-jones.it',
        phone: '+39 123 456 7890',
        website: 'www.indiana-jones-park.it',
        address: 'Via Avventura 1, 12345 Città'
    },
    createdAt: 1704067200000,
    updatedAt: 1704067200000
};